import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal, Select } from 'antd';
import { useMutation } from '@apollo/client';
import classnames from 'classnames';

import formatPrice from '~helpers/currency';
import { REJECT_ORDER_REFUND } from '../../queries';

const RejectModal = ({ t, refundDetails, modalType, type, onSuccess }) => {
  const [showModal, setShowModal] = useState(false);
  const [showErrorTip, setShowErrorTip] = useState(false);
  const [rejectReason, setRejectReason] = useState();

  const handleCloseOrOpenModal = () => {
    setShowModal(!showModal);
    setShowErrorTip(false);
    setRejectReason();
  };

  const [rejectOrderRefund, { loading }] = useMutation(REJECT_ORDER_REFUND, {
    variables: {
      input: {
        id: refundDetails.id,
        rejectReason,
      },
    },
    onCompleted: () => {
      handleCloseOrOpenModal();

      onSuccess?.();
    },
  });

  // reject 接口
  const handleReject = () => {
    if (!rejectReason) {
      setShowErrorTip(true);
    } else {
      rejectOrderRefund();
    }
  };

  return (
    <div className="reject-modal">
      <Choose>
        <When condition={type === 'tableBtn'}>
          <button
            className="refund__table-btn refund__table-btn--border refund__table-reject-btn"
            onClick={handleCloseOrOpenModal}
          >
            {t('cms.billing.refund.table.reject')}
          </button>
        </When>
        <Otherwise>
          <Button type="danger" className="refund-modal__btn" onClick={handleCloseOrOpenModal}>
            {t('cms.billing.refund.table.reject')}
          </Button>
        </Otherwise>
      </Choose>

      <Modal
        visible={showModal}
        width={880}
        className="reject-modal__content"
        title={t('cms.billing.refund.table.reject_modal.title')}
        footer={[
          <Button key="back" style={{ height: 40 }} onClick={handleCloseOrOpenModal}>
            {t('cms.billing.transfer.cancel.btn')}
          </Button>,
          <Button
            key="submit"
            type="danger"
            style={{ height: 40, marginLeft: 16 }}
            loading={loading}
            onClick={handleReject}
          >
            {t('cms.properties.pending_approval.review_modal.reject.btn')}
          </Button>,
        ]}
        onCancel={handleCloseOrOpenModal}
      >
        <div className="reject-modal__basic-info">
          <div className="reject-modal__basic-info-desc">
            <p className="reject-modal__basic-info-text">
              {t('cms.billing.refund.table.reject_modal.notice')}
            </p>
            <p className="reject-modal__basic-info-text">
              {t('cms.billing.refund.table.reject_modal.notice1')}
            </p>
          </div>
          <div className="reject-modal__invoice-info-form">
            <Row gutter={24}>
              <Col span={12}>
                <span className="reject-modal__label">
                  {t('cms.billing.refund.table.filter.refund_from.label')}:&nbsp;
                  {refundDetails.refundFrom
                    ? t(
                        `cms.billing.refund.table.refund_from.${
                          modalType === 'refund'
                            ? 'landlord'
                            : refundDetails.refundFrom.toLowerCase()
                        }`,
                      )
                    : '-'}
                </span>
                <span className="reject-modal__label">
                  {t('cms.billing.refund.table.refund_method.field')}:&nbsp;
                  {refundDetails.refundMethod
                    ? t(
                        `cms.billing.refund.table.refund_method.${refundDetails.refundMethod.toLowerCase()}`,
                      )
                    : '-'}
                </span>
              </Col>
              <Col span={12}>
                <span className="reject-modal__label">
                  {t('cms.billing.refund.table.filter.refund_to.label')}:&nbsp;
                  {refundDetails.refundTo
                    ? t(
                        `cms.billing.refund.table.refund_to.${refundDetails.refundTo.toLowerCase()}`,
                      )
                    : '-'}
                </span>
                <span className="reject-modal__label">
                  {t('cms.billing.refund.table.refund_amount.field')}:&nbsp;
                  {refundDetails.amount
                    ? formatPrice(refundDetails.amount, refundDetails.currency, 2)
                    : '-'}
                </span>
              </Col>
              <Col span={12}>
                <span className="reject-modal__label">
                  {t('cms.billing.refund.table.filter.trade_number.label')}:&nbsp;
                  {refundDetails?.transactionNo ?? '-'}
                </span>
              </Col>
            </Row>
          </div>

          <Row className="reject-modal__reason">
            <p className="reject-modal__reason-label">
              {t('cms.billing.refund.table.reject_modal.reject_reason.label')}
            </p>

            <Select
              style={{ width: '100%' }}
              className={classnames(showErrorTip && 'reject-modal__reason-select')}
              value={rejectReason}
              onChange={val => {
                setShowErrorTip(false);
                setRejectReason(val);
              }}
              placeholder={t('cms.billing.refund.table.reject_modal.reject_reason.placeholder')}
            >
              <Select.Option value={t('cms.billing.refund.table.reject_modal.reject_reason.first')}>
                {t('cms.billing.refund.table.reject_modal.reject_reason.first')}
              </Select.Option>
              <Select.Option
                value={t('cms.billing.refund.table.reject_modal.reject_reason.second')}
              >
                {t('cms.billing.refund.table.reject_modal.reject_reason.second')}
              </Select.Option>
            </Select>
            <If condition={showErrorTip}>
              <p className="reject-modal__reason-error-tip">
                {t('cms.billing.refund.table.reject_modal.reject_reason.error.tip')}
              </p>
            </If>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

RejectModal.propTypes = {
  t: PropTypes.func.isRequired,
  refundDetails: PropTypes.object,
  modalType: PropTypes.string,
  type: PropTypes.string,
};

RejectModal.defaultProps = {
  refundDetails: {},
  modalType: 'refunded',
  type: '',
};

export default RejectModal;
